module.exports = __webpack_public_path__ + "static/img/05046C_2_C_20210308_LC.bd5f467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05046C_2_C_20210308_LC.png
// module id = a5QC
// module chunks = 0